import PageWrapper from 'components/utils/PageWrapper';
import Variables from 'pages/Variables';

export const variablesRoutes = {
    path: '/variables',
    element: (
        <PageWrapper titleId="variables_title">
            <Variables />
        </PageWrapper>
    ),
};
